module.exports = __webpack_public_path__ + "static/img/7.bfd50fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/companyLogo-f/7.jpg
// module id = 9Yp0
// module chunks = 0